import Swal from "sweetalert2";
import { config } from "../config.js";
import { post, get } from './baseApi.service.js';

export const apiGetRequestHistory = async (account, lookupValue) => {
  try {
    const value = lookupValue.trim().toLowerCase();
    const query = /^\d{4}$/.test(value) ? { last_number_4: value } : { id_verify: value };
    return await post("/api/user/request-history", { account, ...query });
  } catch (error) {
    return { message: "Không thể tra cứu. Vui lòng thử lại." };
  }
};

export const apiGetSetting = async () => {
  try {
    const result = await get("/api/setting", {site: config.site});
    if (result?.status_code === 200) {
      return result;
    }
  } catch (error) {
    return Swal.fire({ icon: "error", text: "Lỗi kết nối, vui lòng thử lại sau." });
  }
};

export const apiFormUpdateAccount = async (body, files) => {
  try {
    const formData = new FormData();

    // Thêm dữ liệu từ body vào formData
    for (const key in body) {
      formData.append(key, (typeof body[key] === 'object') ? JSON.stringify(body[key]) : body[key] );
    }

    // Thêm files vào formData (nếu có)
    if (files && files.length > 0) {
      files.forEach((file) => {
        formData.append("files", file);
      });
    }
    const result = await post("/api/user/v2/form-info-update",formData);
    if (result.code === 200) {
      return result?.data;
    } else {
      if (result?.data?.html) {
        Swal.fire({
          icon: "error",
          title: result.error,
          html: result.message,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: result.error,
          text: result.message,
        });
      }
      return false;
    }
  } catch (error) {
    console.error("error", error);
    return false;
  }
};

export const apiCheckAccount = async (userName, captcha, token, lastBank) => {
  let raw = {
    account: userName,
    captcha: captcha,
    token: token,
    ...(lastBank ? { last_bank: lastBank } : {})
  };
  try {
    const result = await post("/api/user/check",raw);
    if (result?.code === 200) {
      return result;
    } else {
      if (result?.data?.html) {
        Swal.fire({
          icon: "error",
          title: result.error,
          html: result.message,
        });
      } else {
        Swal.fire({ icon: "error", text: result?.message || "Không thể kiểm tra tài khoản, vui lòng thử lại." });
      }
    }
  } catch (error) {
    return Swal.fire({ icon: "error", text: "Thao tác lỗi, vui lòng thử lại sau." });
  }
};

export const apiUpdateAccount = async (body) => {
  let raw = JSON.stringify(body);
  try {
    const result = await post("/api/user/info-update",raw);
    if (result.code === 200) {
      return true;
    } else {
      if (result?.data?.html) {
        Swal.fire({
          icon: "error",
          title: result.error,
          html: result.message,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: result.error,
          text: result.message,
        });
      }
      return false;
    }
  } catch (error) {
    console.error("error", error);
  }
};

export const apiCheckDataAccount = async (body) => {
  let raw = body;
  // let raw = body;
  try {
    const result = await post("/api/user/v2/check-data-old",raw);
    if (result.code === 200) {
      return result.data;
    } else {
      if(result.code === 202) {
        if (result?.data?.html) {
          Swal.fire({
            icon: "error",
            title: result.error,
            html: result.message,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: result.error,
            text: result.message,
          });
        }
      }
      return false;
    }
  } catch (error) {
    console.error("error", error);
  }
};

export const getCaptchaTokenClient = async () => {
  let myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  let requestOptions = {
    method: "get",
    redirect: "follow",
    headers: myHeaders,
  };
  return await fetch(`${config.BE_API_URL}/api/get-verification-code?site=f168`,
    requestOptions
  )
    .then((response) => response.json())
    .then((result) => {
      return result;
    })
    .catch((error) => console.log("error", error));
};

export const verifyCaptchaTokenClient = async (captchaInput, clientToken) => {
  let myHeaders = new Headers();
  myHeaders.append("Authorization", clientToken);
  myHeaders.append("Content-Type", "application/json");

  const raw = JSON.stringify({
    captchaCode: captchaInput,
    token: clientToken,
  });

  let requestOptions = {
    method: "POST",
    redirect: "follow",
    headers: myHeaders,
    body: raw,
  };
  return await fetch(`${config.BE_API_URL}/api/verify-captcha?site=f168`,
    requestOptions
  )
    .then((response) => response.json())
    .then((result) => {
      return result;
    })
    .catch((error) => console.log("error", error));
};

export const apiConfirmUpdate = async (body) => {
  let myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  let raw = JSON.stringify(body);
  let requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
  };

  try {
    const response = await fetch(`${config.BE_API_URL}/api/user/confirm-update`, requestOptions);
    const result = await response.json();
    if (result.code === 200) {
      return result.data;
    } 
  } catch (error) {
    console.error("error", error);
  }
};

export const checkLastPhoneNumber = async (account, lastPhoneNumber) => {
  let raw = {
    account: account,
    last_phone_number: lastPhoneNumber
  };
  try {
    const result = await post("/api/user/v2/check-phone-number",raw);
    if (result.code === 200 && result.data?.result) {
      return true;
    } else {
      if(result.code === 202) {
        if (result?.data?.html) {
          Swal.fire({
            icon: "error",
            title: result.error,
            html: result.message,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: result.error,
            text: result.message,
          });
        }
      }
      return false;
    }
  } catch (error) {
    console.error("error", error);
  }
};

export const checkStatusUpdate = async (account, idVerify) => {
  let raw = {
    account: account,
    id_verify: idVerify
  };
  try {
    const result = await post("/api/user/v2/check-status-update",raw);
    if (result.code === 200 && result.data) {
      return result.data;
    } else {
      if(result.code === 202) {
        if (result?.data?.html) {
          Swal.fire({
            icon: "error",
            title: result.error,
            html: result.message,
          });
        }
      }
      return false;
    }
  } catch (error) {
    console.error("error", error);
    return false;
  }
};
